<template>
  <div id="newMyAccount">
    <div class="row" style="margin: 0px">
      <div class="myaccount-left-container">
        <div class="left-header-container" style="text-align: left">
          <div style="margin-bottom: 20px">
            <a href="/StaffMainPage">
              <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
              {{ lang('Back to main page') }}
            </a>
          </div>

          <div class="default-img-container">
            <img src="../assets/Vector14.png" />
          </div>

          <div style="display: inline-block; max-width: 80%">
            <label style="margin-bottom: 0px; line-height: 16px">{{ lang('Account') }}</label>
            <small style="color: #536170">{{ lang('Edit and manage your account details') }}</small>
          </div>
        </div>

        <hr />

        <div class="left-body-container" style="text-align: left">
          <div class="ma-profile-container" v-on:click="showProfileModal">
            <img v-bind:src="imgStaffProfileOut" type="file" class="imgStaffProfile" />
          </div>

          <div style="display: inline-block; max-width: 80%; margin: 10px 0px">
            <label style="margin-bottom: 0px; line-height: 16px">{{ userName }}</label>
            <small style="color: #536170">{{ lang('Parent') }}</small>
          </div>

          <div style="margin-top: 40px">
            <div style="padding: 10px; border-bottom: 0.5px solid #d3d9e8; cursor: pointer" @click="setIsClick('resetP')">
              <div class="ma-select-type row" style="margin: 0px" :class="isClickType === 'resetP' ? 'active' : ''">
                <span>{{ lang('Reset Password') }}</span>

                <span style="margin-left: auto">
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
              </div>
            </div>

            <div style="padding: 10px; border-bottom: 0.5px solid #d3d9e8; cursor: pointer" @click="setIsClick('setting')">
              <div class="ma-select-type row" style="margin: 0px" :class="isClickType === 'setting' ? 'active' : ''">
                <span>{{ lang('settings') }}</span>

                <span style="margin-left: auto">
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="myaccount-right-container">
        <div style="padding: 20px">
          <div v-if="isClickType === 'resetP'" style="width: 70%; margin: 0 auto">
            <div style="margin-bottom: 30px; border-bottom: 0.5px solid #d3d9e8; padding: 20px 0px">
              <!--                            <span style="color: #536170;">** {{lang("Your password needs to have at least 6 characters")}}</span>-->
              <span style="color: #536170">** Your password must include uppercase, lowercase, number, and have at least 8 characters.</span>
            </div>

            <div>
              <div class="reset-content" style="width: 80%; margin: 0 auto">
                <form class="needs-validation" novalidate @submit.prevent="onSubmit">
                  <div class="mb-3 form-group" :class="{ 'form-group--error': $v.oldPassword.$error }">
                    <input
                      type="password"
                      class="form-control"
                      id="oldPassword"
                      v-model="oldPassword"
                      autocomplete="false"
                      :placeholder="lang('Old Password')"
                    />
                  </div>
                  <!--                            <div class="error" v-if="!$v.oldPassword.required">-->
                  <!--                                {{lang('Please enter current password')}}-->
                  <!--                            </div>-->

                  <div class="mb-3 form-group" :class="{ 'form-group--error': $v.userPassword1.$error }">
                    <input
                      type="password"
                      class="form-control"
                      id="userPassword1"
                      v-model="userPassword1"
                      autocomplete="false"
                      :placeholder="lang('New Password')"
                      v-model.trim="$v.userPassword1.$model"
                    />
                  </div>
                  <!--                            <div class="error" v-if="!$v.userPassword1.required">-->
                  <!--                                {{lang('Password is required')}}-->
                  <!--                            </div>-->
                  <!--                            <div class="error" v-if="!$v.userPassword1.minLength">-->
                  <!--                                {{lang('Password must have at least 6 letters.')}}-->
                  <!--                            </div>-->

                  <div class="mb-3 form-group" :class="{ 'form-group--error': $v.userPassword2.$error }">
                    <input
                      type="password"
                      class="form-control"
                      id="userPassword2"
                      v-model="userPassword2"
                      autocomplete="false"
                      :placeholder="lang('Confirm New Password')"
                      v-model.trim="$v.userPassword2.$model"
                    />
                  </div>
                  <!--                            <div class="error" v-if="!$v.userPassword2.required">{{lang('Password is required')}}</div>-->
                  <!--                            <div class="error" v-if="!$v.userPassword2.minLength">{{lang('Password must have at least 6 letters.')}}-->
                  <!--                            </div>-->

                  <div class="system-msg">
                    <p>{{ results }}</p>
                  </div>
                  <div class="row d-flex mt-3 mb-5">
                    <div class="col-md-12">
                      <button class="btn btn-primary" type="submit" style="width: 100%" v-show="isLoading === false">
                        {{ lang('Save') }}
                      </button>
                      <div class="loading" v-if="isLoading === true">
                        <div class="load-3">
                          <div class="line"></div>
                          <div class="line"></div>
                          <div class="line"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div v-if="isClickType === 'setting'" style="width: 85%; margin: 0 auto">
            <div class="row" style="margin: 20px 0px; text-align: left">
              <span style="font-size: 16px; width: 85%">{{ lang('Enable / Disable receive email reminder for new update') }}</span>
              <el-switch v-model="allowNtf" style="margin-left: auto; width: 15%"></el-switch>

              <div v-if="allowNtf">
                <el-select v-model="ntfValue" placeholder="Select">
                  <el-option v-for="item in ntfOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </div>
            </div>

            <div>
              <button class="btn btn-primary" type="submit" style="width: 100%" @click="setNotification()">
                {{ lang('Save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal_uploadProfile" title="Update Profile Picture" ref="modal_uploadProfile" centered hide-footer hide-header>
      <!--            <H5 class="mt-2 mb-4">{{lang('Profile Photo')}}</H5>-->
      <!--            <div class="myaccount-image_wrap">-->
      <!--                <div class="myaccount-image_overlay" @click="uploadStaffProfileImg()"><i class="material-icons">-->
      <!--                    add_circle_outline-->
      <!--                </i>  {{lang('Browse')}}</div>-->
      <!--                <img v-bind:src="imgStaffProfile" type="file"-->
      <!--                     class="imgStaffProfile" />-->
      <!--            </div>-->

      <div style="text-align: center">
        <img v-bind:src="imgStaffProfile" type="file" class="imgStaffProfile" style="width: 120px; height: 120px; object-fit: cover; border-radius: 50%" />

        <span style="display: block; font-weight: bold; font-size: 18px; margin: 15px 0px">{{ lang('Upload Profile Image') }}</span>

        <button class="btn" @click="uploadStaffProfileImg()" style="background: #91a3b6; border-radius: 5px; color: #ffffff; width: auto">
          <i class="fa fa-link" aria-hidden="true"></i> {{ lang('BROWSE IMAGE') }}
        </button>
      </div>

      <!--            <el-button type="primary" v-on:click="SaveStaff"  round class="mt-4 mb-2"><span>{{lang('Save Profile Photo')}}</span></el-button>-->
      <input type="file" ref="file" accept="image/*" style="display: none" @change="previewImgStaffProfile" />

      <div
        class="modal-profile-footer-container row"
        style="margin-top: 30px; background: #f8faff; border-top: 0.5px solid #c8e3ff; padding: 15px 15px 0px 15px"
      >
        <el-button type="primary" v-on:click="hideProfileModal" style="width: auto; background: #606265; border-color: #606265">
          <span style="white-space: pre-line">{{ lang('Cancel') }}</span>
        </el-button>

        <el-button type="primary" v-on:click="SaveStaff" style="width: auto; margin-left: auto">
          <span style="white-space: pre-line">{{ lang('Update') }}</span>
        </el-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import { required, minLength } from 'vuelidate/lib/validators'
import Cookies from 'js-cookie'
import ProfileImg from '../assets/boy.png'
import { lang } from '../locale/index'
import $ from 'jquery'

export default {
  name: 'NewMyAccount',
  components: {},
  data() {
    return {
      isClick: false,
      allowNtf: false,
      ntfOption: [
        {
          value: 'Daily',
          label: lang('Daily'),
        },
        {
          value: 'Weekly',
          label: lang('Weekly'),
        },
        {
          value: 'Monthly',
          label: lang('Monthly'),
        },
      ],
      ntfValue: 'Daily',

      userType: '',
      userName: '',
      isClickType: 'resetP',

      //reset password
      results: '',
      oldPassword: '',
      userPassword1: '',
      userPassword2: '',
      isLoading: false,
      //end:reset password

      imgStaffProfile: '',
      imgStaffProfileOut: '',
    }
  },
  async created() {
    this.imgStaffProfile = ProfileImg
    this.imgStaffProfileOut = ProfileImg

    this.userType = Cookies.get('userTypeSession')
    this.userName = Cookies.get('userNameSession')

    await this.getConfigNotificationByType()
    await this.LoadProfileImg()
  },
  destroyed() {},
  methods: {
    lang,

    async onSubmit() {
      try {
        //if old password doesnt match
        if (this.oldPassword === null || this.userPassword1 === null || this.userPassword2 === null) {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Please fill in all field'),
          })
        } else if (this.userPassword1 !== this.userPassword2) {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Password not match'),
          })
        } else if (!this.checkPasswordStrength1() || !this.checkPasswordStrength2()) {
          this.$notify.error({
            title: lang('Error'),
            message: 'Your password must include uppercase, lowercase, number, and have at least 8 characters.',
          })
        } else if (this.userPassword1.length < 8 || this.userPassword2.length < 8) {
          this.$notify.error({
            title: lang('Error'),
            message: 'Password must have at least 8 letters.',
          })
        } else {
          this.isLoading = true
          const response = await DataSource.shared.resetPasswordByPassword(this.oldPassword, this.userPassword1)
          this.isLoading = false
          if (response) {
            switch (response.code) {
              case '1':
                this.$notify({
                  title: lang('Success'),
                  message: lang('Password Reset'),
                  type: 'success',
                })
                window.location.replace('/NewMyAccount')
                // this.results = `Password Reset`;
                break
              case '2':
                this.$notify.error({
                  title: lang('Error'),
                  message: lang('Current password wrong'),
                })
                // this.results = `Current password wrong`;
                break
              case '88':
                window.location.replace('/')
                break
              case '99':
                this.$notify.error({
                  title: lang('Error'),
                  message: lang('Please fill in all field'),
                })
                break
            }
          }
        }
      } catch (e) {
        this.results = e
        this.isLoading = false
      }
    },

    setIsClick(val) {
      this.isClick = true
      this.isClickType = val
    },

    backToList() {
      this.isClick = false
    },

    backToMain() {
      window.location.replace('/StaffMainPage')
    },

    async setNotification() {
      let ntfType = 'Off'

      if (this.allowNtf) {
        ntfType = this.ntfValue
      }

      let arrNtf = []
      let objNtf = {}
      objNtf.Type = 'NotificationFrequent'
      objNtf.Value = ntfType

      arrNtf.push(objNtf)

      this.$vs.loading()
      try {
        const response = await DataSource.shared.updateUserConfiguration(JSON.stringify(arrNtf))
        if (response) {
          if (response.code === '2') {
            // this.$notify.error({
            //     title: lang('Error'),
            //     message: lang('No record found')
            // });
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: lang('Error'),
              message: lang('Please try again later'),
            })
          } else {
            this.$notify({
              title: 'Successfully',
              message: 'Successfully Updated',
            })
          }
        }
        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },

    async getConfigNotificationByType() {
      try {
        this.$vs.loading()

        let arrType = []
        let objType = {}
        objType.Type = 'NotificationFrequent'

        arrType.push(objType)

        const response = await DataSource.shared.getUserConfigurationValueByType(JSON.stringify(arrType))
        if (response) {
          if (response.code === '2') {
            // this.$notify.error({
            //     title: 'Error',
            //     message: 'No record found'
            // });
            this.allowNtf = false
          } else if (response.code === '99') {
            // this.$notify.error({
            //     title: 'Error',
            //     message: 'Please try again later'
            // });
            console.log('99')
          } else {
            if (response.Table) {
              if (response.Table[0].UsrConfigValue === 'Off') {
                this.allowNtf = false
                this.ntfValue = 'Daily'
              } else {
                this.allowNtf = true
                this.ntfValue = response.Table[0].UsrConfigValue
              }
            }
          }
        }
        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },

    showProfileModal() {
      this.imgStaffProfile = this.imgStaffProfileOut
      this.$refs.modal_uploadProfile.show()
    },

    hideProfileModal() {
      this.$refs.modal_uploadProfile.hide()
    },

    async uploadStaffProfileImg() {
      try {
        this.$refs.file.click()
      } catch (e) {
        this.results = e
      }
    },

    previewImgStaffProfile: function (event) {
      try {
        var input = event.target
        if (input.files && input.files[0]) {
          var reader = new FileReader()
          reader.onload = e => {
            this.imgStaffProfile = e.target.result
          }
          reader.readAsDataURL(input.files[0])
          this.selectedFile = event.target.files
        }
      } catch (e) {
        this.results = e
      }
    },

    async SaveStaff() {
      const response = await DataSource.shared.saveStaffProfileImage(this.selectedFile)
      if (response) {
        if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '1') {
          this.$notify({
            title: lang('Success'),
            message: lang('Records Successfully Saved'),
            type: 'success',
          })

          this.imgStaffProfileOut = this.imgStaffProfile
          // window.location.replace('/NewMyAccount');
          this.hideProfileModal()
        } else {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Save Staff Error - Please try again later'),
          })
        }
      }
    },

    async LoadProfileImg() {
      try {
        const staffProPic = await DataSource.shared.getStaffProfileImage()
        if (staffProPic) {
          if (staffProPic.code !== '2' && staffProPic.code !== '88' && staffProPic.code !== '99') {
            let image64String = this.ConvertBase64StringToImage(staffProPic.Table[0])
            // image64String !== '' ? this.imgStaffProfile = image64String : '';

            if (image64String !== '') {
              this.imgStaffProfile = image64String
              this.imgStaffProfileOut = image64String
            }
          }
        }
      } catch (e) {
        this.result = e
      }
    },

    ConvertBase64StringToImage(file) {
      if (this.isImage(file)) return 'data:' + file.UPPImageFileType + ';base64,' + file.UPPImage
      else return ''
    },

    isImage(obj_File) {
      let ext = String(obj_File.UPPImageFileExt).toUpperCase()
      let isImage = false

      switch (ext) {
        case '.PNG':
        case '.JPG':
        case '.BMP':
        case '.GIF':
        case '.JPEG':
          isImage = true
          break
        default:
          isImage = false
          break
      }
      return isImage
    },

    checkPasswordStrength1() {
      var isValid = false
      if (/[A-Z]/.test(this.userPassword1) && /[a-z]/.test(this.userPassword1) && /[0-9]/.test(this.userPassword1) && this.userPassword1.length >= 8) {
        isValid = true
      }
      return isValid
    },

    checkPasswordStrength2() {
      var isValid = false
      if (/[A-Z]/.test(this.userPassword2) && /[a-z]/.test(this.userPassword2) && /[0-9]/.test(this.userPassword2) && this.userPassword2.length >= 8) {
        isValid = true
      }
      return isValid
    },

    getPathQuery() {
      const currentUrl = window.location.href
      const url = new URL(currentUrl)
      return url.searchParams.get('id')
    },
  },
  mounted() {
    if (this.getPathQuery() === 'settings') {
      this.setIsClick('setting')
    }
  },
  props: [],
  validations: {
    //reset password
    newPassword: '',
    oldPassword: {},
    userPassword1: {
      required,
      // minLength: minLength(6)
      strongPassword1(userPassword1) {
        return (
          /[A-Z]/.test(userPassword1) && // checks for A-Z
          /[a-z]/.test(userPassword1) && // checks for a-z
          /[0-9]/.test(userPassword1) && // checks for 0-9
          // /\W|_/.test(userPassword1) && // checks for special char
          userPassword1.length >= 8
        )
      },
    },
    userPassword2: {
      required,
      // minLength: minLength(6)
      strongPassword2(userPassword2) {
        return (
          /[A-Z]/.test(userPassword2) && // checks for A-Z
          /[a-z]/.test(userPassword2) && // checks for a-z
          /[0-9]/.test(userPassword2) && // checks for 0-9
          // /\W|_/.test(userPassword2) && // checks for special char
          userPassword2.length >= 8
        )
      },
    },
  },
}
</script>

<style scoped>
.myaccount-image_wrap {
  margin: 0px auto;
  top: 0px;
}

.myaccount-left-container {
  width: 30%;
  background: #ffffff;
  height: calc(100vh - 93px);
  max-height: calc(100vh - 93px);
  overflow: auto;
  padding: 20px;
}

.myaccount-right-container {
  width: 70%;
  height: calc(100vh - 93px);
  max-height: calc(100vh - 93px);
  overflow: auto;
}

.default-img-container {
  background: #426dff;
  padding: 5px;
  border-radius: 7px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}

.ma-profile-container {
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
  cursor: pointer;
}

.ma-profile-container .imgStaffProfile {
  object-fit: cover;
  width: 60px;
  height: 60px;
  border-radius: 10px;
}

.ma-select-type.active {
  color: #426dff;
}
</style>

<style>
div#modal_uploadProfile .myaccount-image_wrap {
  margin-bottom: 0px;
}

.newMyAccount #main-content {
  padding: 0px;
}

.newMyAccount #modal_uploadProfile .modal-content {
  width: 50%;
  margin: auto;
}
</style>
